export default __webpack_public_path__ + "static/media/sad-cloud.ece34e4a.svg";